'use strict';

export default class Cars {
  constructor(appConfig, $http, $q) {
    'ngInject';

    this._appConfig = appConfig;
    this._$http = $http;
    this._$q = $q;
  }

  getCarList(year, make) {
    // Create the $http object for this request
    let request = {
      method: 'GET',
    };

    if(!make) {
      request.url = `${this._appConfig.api}/cars/${year}`;
    } else {
      request.url = `${this._appConfig.api}/cars/${year}/${make}`;
    }
    return this._$http(request).then(res => res.data);
  }

}



// WEBPACK FOOTER //
// ./client/components/services/cars.service.js